export var LOCAL_STORAGE_KEYS;
(function (LOCAL_STORAGE_KEYS) {
    LOCAL_STORAGE_KEYS["COMMUNTY_ACCOUNT_TOKEN"] = "COMMUNTY_ACCOUNT_TOKEN";
    LOCAL_STORAGE_KEYS["TAP_FEED_ACCOUNT_TOKEN"] = "TapAccountInteractionSite";
})(LOCAL_STORAGE_KEYS || (LOCAL_STORAGE_KEYS = {}));
;
